export default "__VITE_ASSET__e1c3345c__"